import Categories from './Categories';

export default Categories;
export * from './Categories';
